<div
  [ngClass]="{ 'btn-group': !blockBtns, 'block-btns': blockBtns }"
  *ngIf="(buttons | async)?.length > 0 || (individualButtons | async)?.length > 0"
>
  <ng-container *ngFor="let button of individualButtons | async">
    <span
      class="d-inline-block"
      [ngbTooltip]="button.tooltip ? (button.tooltip | translate) : null"
      container="body"
    >
      <button
        class="btn btn-outline-primary {{ button.class }}"
        (click)="$event.preventDefault(); $event.stopPropagation(); button.action(item, $event)"
        [disabled]="button.disable"
      >
        <i *ngIf="button.icon" class="{{ button.icon }}"></i><span translate>{{ button.title }}</span>
      </button>
    </span>
  </ng-container>
  <div
    ngbDropdown
    placement="{{placement}}"
    class="d-inline-block mr-2"
    [class.w-100]="blockBtns"
    *ngIf="(buttons | async)?.length > 0"
  >
    <button class="btn btn-outline-primary {{btnClass}}" id="dropdownBasic1" ngbDropdownToggle translate>{{title}}</button>
    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-container">
      <ng-container *ngFor="let button of buttons | async">
        <div
          [ngbTooltip]="button.tooltip ? (button.tooltip | translate) : null"
          container="body"
        >
          <button
            ngbDropdownItem
            (click)="$event.preventDefault(); $event.stopPropagation(); button.action(item, $event)"
            [disabled]="button.disable"
          >
            <i *ngIf="button.icon" class="{{ button.icon }}"></i><span translate>{{ button.title }}</span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
